import React from "react";
const Description = ({
  description,
  isError
}) => {
  if (!description) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: "general-text",
    className: "general-input-label",
    style: {
      display: "block",
      marginBottom: "6px"
    }
  }, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: description ?? ""
    },
    style: {
      fontSize: "12px",
      color: isError ? "#FDA29B" : undefined
    }
  }));
};
export default Description;
//# sourceMappingURL=Description.js.map